module.exports = __webpack_public_path__ + "static/media/4.1-notes.9fd348ee.png";